import React from "react";
import { Row, Col, Placeholder, Spinner } from "react-bootstrap";
import MainCard from "../../Components/Cards/MainCard";

const ReferralAgreementSkeleton = () => {
  return (
    <MainCard>
      {/* --- Top Filter Section --- */}
      <Row className="mb-3">
        {/* Input */}
        <Col xs={12} sm={12} md={3} lg={3} xl={6} className="mb-2 mb-md-0">
          <Placeholder as="input" animation="wave" className="form-control" />
        </Col>

        {/* Select 1 */}
        <Col xs={12} sm={12} md={3} lg={3} xl={2} className="mb-2 mb-md-0">
          <Placeholder as="select" animation="wave" className="form-select">
            <option>Loading...</option>
          </Placeholder>
        </Col>

        {/* Select 2 */}
        <Col xs={12} sm={12} md={3} lg={3} xl={2} className="mb-2 mb-md-0">
          <Placeholder as="select" animation="wave" className="form-select">
            <option>Loading...</option>
          </Placeholder>
        </Col>

        {/* Button */}
        <Col xs={12} sm={12} md={3} lg={3} xl={2}>
          <Placeholder.Button variant="primary" xs={12} />
        </Col>
      </Row>

      {/* --- Table Skeleton --- */}
      <div className="p-3 border rounded">
        {[...Array(5)].map((_, i) => (
          <Row
            key={i}
            className="align-items-center mb-3 border-bottom pb-2 gx-3"
          >
            {/* 7 Columns Placeholder */}
            {[...Array(7)].map((_, colIndex) => (
              <Col key={colIndex}>
                <Placeholder as="div" animation="wave" className="w-100">
                  <Placeholder xs={8} />
                </Placeholder>
              </Col>
            ))}
          </Row>
        ))}
      </div>
    </MainCard>
  );
};

export default ReferralAgreementSkeleton;
